import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { INFINITE_CACHE_AND_STALE_TIME } from 'constants/index';
import { generateFilter, generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import type { SparkRunInputParameterRecommendationResponse } from 'types/Spark/SparkRunInputParameterRecommendations';

const getSparkRunInputParameterRecommendations = (
  sparkRunRecommendationID: string | undefined
) => {
  if (!sparkRunRecommendationID) {
    Promise.reject('sparkRunRecommendationID is not found');
    return;
  }
  const queryArray = [
    generateFilter('sparkRunRecommendationID', sparkRunRecommendationID),
  ];
  const url = generateURL(
    SPARK_RESOURCE_TYPES.SPARK_RUN_INPUT_PARAMETER_RECOMMENDATIONS,
    queryArray
  );

  return fetchWrapper<SparkRunInputParameterRecommendationResponse>({
    url: url,
    method: 'GET',
  });
};

export function useSparkRunInputParameterRecommendations(
  sparkRunRecommendationID: string | undefined,
  enabled = true
) {
  const response = useQuery(
    ['sparkRunInputParameterRecommendations', sparkRunRecommendationID],
    () => getSparkRunInputParameterRecommendations(sparkRunRecommendationID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `Failed to fetch Spark Run Input Parameter Recommendations: ${error.message}`
          );
        }
      },
      enabled: Boolean(sparkRunRecommendationID && enabled),
      ...INFINITE_CACHE_AND_STALE_TIME,
    }
  );

  const { data: sparkRunInputParameterRecommendations } = response.data || {};

  return {
    sparkRunInputParameterRecommendations,
    ...response,
  };
}
